import { useEffect, useState } from "react"

/**
 * How long to wait after a key press until the search
 * is executed.
 */
export const SEARCH_DEBOUNCE_DELAY_MS = 100

const useDebounce = <T>(value: T, delayMs: number) => {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounced(value)
    }, delayMs)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delayMs])

  return debounced
}

export default useDebounce
